// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import './fieldEditor';

/**
 * Text input for fields of type string. <br/>
 * Will present a text area if the max length is not defined or is greater than 100 characters
 * Superclass for: <br/>
 *        {@link FileFieldEditor} <br/>
 *        {@link ImageFieldEditor} <br/>
 * @name StringFieldEditor
 * @constructor
 * @extends {FieldEditor}
 */
myw.StringFieldEditor = myw.FieldEditor.extend({
    initialize(owner, feature, fieldDD, options) {
        myw.FieldEditor.prototype.initialize.call(this, owner, feature, fieldDD, options);
        const maxLength = this.maxLength();
        if (isNaN(maxLength) || maxLength > 100) {
            this.control = new myw.Textarea({
                text: this.fieldValue,
                onChange: this._changed.bind(this)
            });
            this.setElement(this.control.$el);
            return;
        }
        this.control = new myw.Input({
            value: this.fieldValue,
            onChange: this._changed.bind(this)
        });
        this.setElement(this.control.$el);
    },

    /**
     * returns the length of a myworld string field from the DD
     * @param  {string} fieldType from the DD e.g.: 'string(32)'
     * @return {integer}
     */
    maxLength() {
        const fieldType = this.fieldDD.type,
            lengthStr = fieldType
                .split('(')
                .pop()
                .slice(0, -1);
        return parseInt(lengthStr, 10);
    }
});

export default myw.StringFieldEditor;
